export function asUint8Array(buf){return null!=globalThis.Buffer?new Uint8Array(buf.buffer,buf.byteOffset,buf.byteLength):buf}